/**
 * Created by etzay on 19.12.16.
 */
import {BonusScene} from 'bonus_scene';

import {Animation} from 'animation';

import {Button} from 'button';

const Sprite = PIXI.Sprite;
const TextureCache = PIXI.utils.TextureCache;
const BitmapText = PIXI.extras.BitmapText;

export default class SuperBonusGameScene extends BonusScene {

    constructor() {
        super();

        this.coordButtons = {
            x: [-2, 67, 399, 434, 666],
            y: [393, 388, 505, 248, 333]
        };

        this.coordWinLabel = {
            x: [64, 207, 560, 559, 735],
            y: [444, 488, 540, 340, 405]
        };

        this.objectsName = ["ewer", "chest", "drawer", "cupboard", "commode"];
        this.winFramesCount = [22, 21, 17, 16, 15];
        this.winAnimationOffsets = {
            x: [12, 34, -45, -74, -122],
            y: [0, -110, -52, 2, 2]
        };

        this.superBonusBack = new PIXI.Sprite(PIXI.utils.TextureCache["res/superbonus_background.jpg"]);
        this.addChild(this.superBonusBack);

        this.animPaintingsLight = Animation.byFrameName("paints_light_%03d.png", 10);
        this.animPaintingsLight.loop = false;
        this.animPaintingsLight.animationSpeed = 0.1;
        this.animPaintingsLight.position.set(0, 53);
        this.animPaintingsLight.visible = false;
        this.addChild(this.animPaintingsLight);

        this.animMather = Animation.byFrameName("mather_%03d.png", 33);
        this.animMather.loop = false;
        this.animMather.animationSpeed = 0.1;
        this.animMather.position.set(-2, 157);
        this.animMather.visible = true;
        this.addChild(this.animMather);

        this.animFather = Animation.byFrameName("father_%03d.png", 22);
        this.animFather.loop = false;
        this.animFather.animationSpeed = 0.1;
        this.animFather.position.set(221, 164);
        this.animFather.visible = true;
        this.addChild(this.animFather);

        this.animIdle = Animation.byFrameName("waterman_idol_%03d.png", 10);
        this.animIdle.loop = true;
        this.animIdle.animationSpeed = 0.1;
        this.animIdle.position.set(133, 240);
        this.animIdle.visible = true;
        this.addChild(this.animIdle);

        this.animLose = Animation.byFrameName("waterman_wake_up_%03d.png", 16);
        this.animLose.loop = false;
        this.animLose.animationSpeed = 0.1;
        this.animLose.position.set(133, 240);
        this.animLose.visible = false;
        this.addChild(this.animLose);

        this.objectsButton = [];
        this.winAnimations = [];
        this.objectNumbers = [];
        for (let i = 0; i < 5; i++) {
            const button_name = this.objectsName[i] + "_idol_%03d.png";
            const win_name = this.objectsName[i] + "_win_%03d.png";
            const number_name = "place_number_%d".$(i) + ".png";

            const button = Animation.byFrameName(button_name, 7);
            button.loop = true;
            button.animationSpeed = 0.1;
            button.interactive = true;
            button.buttonMode = true;
            button.position.set(this.coordButtons.x[i], this.coordButtons.y[i]);

            this.addChild(button);
            //button.enabled = false;
            this.objectsButton.push(button);

            // вызываем обработчик, в качестве параметра передаем индекс кнопки в массиве и делаем кнопку неактивной
            button.on('pointerdown', () => {
                this.objectsButton[i].interactive = false;
                this.objectsButton[i].gotoAndStop(0);
                // this.visible = false;
                this.onUserSelect(i);
            });

            const win_anim = Animation.byFrameName(win_name, this.winFramesCount[i]);
            win_anim.loop = false;
            win_anim.animationSpeed = 0.1;
            win_anim.visible = false;
            win_anim.position.set(this.coordButtons.x[i] + this.winAnimationOffsets.x[i], this.coordButtons.y[i] + this.winAnimationOffsets.y[i]);
            this.addChild(win_anim);
            this.winAnimations.push(win_anim);

            const object_number = new PIXI.Sprite(PIXI.utils.TextureCache[number_name]);
            object_number.position.set(this.coordWinLabel.x[i], this.coordWinLabel.y[i]);
            object_number.anchor.set(0.5, 0.5);
            object_number.visible = true;
            this.addChild(object_number);
            this.objectNumbers.push(object_number);
        }

        // this.findAPrizeLabel = new PIXI.Sprite(PIXI.utils.TextureCache["find_a_prize.png"]);
        // this.addChild(this.findAPrizeLabel);

        this.plateForBet = new PIXI.Sprite(PIXI.utils.TextureCache["plate_for_bet.png"]);
        this.plateForBet.position.set(250, 692);
        this.addChild(this.plateForBet);
        this.plateBetLabel = new PIXI.Sprite(PIXI.utils.TextureCache["bonus_total_bet.png"]);
        this.plateBetLabel.position.set(250, 748);
        this.addChild(this.plateBetLabel);
        this.totalBetLabel = new PIXI.extras.BitmapText("", {font: "status-font", align: "left"});//new PIXI.extras.BitmapText("", {font: "bonus-font", align: "left"});
        this.totalBetLabel.position.set(65, 25);
        this.totalBetLabel.anchor.set(0.5, 0);
        this.plateForBet.addChild(this.totalBetLabel);
        this.plateForWin = new PIXI.Sprite(PIXI.utils.TextureCache["plate_for_win.png"]);
        this.plateForWin.position.set(400, 690);
        this.addChild(this.plateForWin);
        this.plateWinLabel = new PIXI.Sprite(PIXI.utils.TextureCache["bonus_winner_paid.png"]);
        this.plateWinLabel.position.set(422, 748);
        this.addChild(this.plateWinLabel);
        this.winLabel = new PIXI.extras.BitmapText("", {font: "status-font", align: "left"});//new PIXI.extras.BitmapText("", {font: "bonus-font", align: "left"});
        this.winLabel.position.set(102, 26);
        this.winLabel.anchor.set(0.5, 0);
        this.plateForWin.addChild(this.winLabel);
        this.plateForCredits = new PIXI.Sprite(PIXI.utils.TextureCache["plate_for_credits.png"]);
        this.plateForCredits.position.set(610, 690);
        this.addChild(this.plateForCredits);
        this.plateCreditsLabel = new PIXI.Sprite(PIXI.utils.TextureCache["bonus_credits.png"]);
        this.plateCreditsLabel.position.set(697, 748);
        this.addChild(this.plateCreditsLabel);
        this.creditLabel = new PIXI.extras.BitmapText("", {font: "status-font", align: "left"});//new PIXI.extras.BitmapText("", {font: "bonus-font", align: "left"});
        this.creditLabel.position.set(138, 26);
        this.creditLabel.anchor.set(0.5, 0);
        this.plateForCredits.addChild(this.creditLabel);

        this.addWinLabel = [];
        for (let i = 0; i < 5; i++) {
            const label = new PIXI.extras.BitmapText("", {font: "superbonus_font", align: "center"});
            label.anchor.set(0.5, 0.5);
            label.position.set(this.coordButtons.x[0], this.coordButtons.y[i]);
            label.visible = false;
            this.addChild(label);
            this.addWinLabel.push(label);
        }

        this.sndLose = sounds.get("res/sounds/bonus/superbonus_lose");
        this.sndWin = [];
        this.sndWin.push(sounds.get("res/sounds/bonus/superbonus_place_0"));
        this.sndWin.push(sounds.get("res/sounds/bonus/superbonus_place_1"));
        this.sndWin.push(sounds.get("res/sounds/bonus/superbonus_place_2"));
        this.sndWin.push(sounds.get("res/sounds/bonus/superbonus_place_3"));
        this.sndWin.push(sounds.get("res/sounds/bonus/superbonus_place_4"));

        this.sndFon = sounds.get("res/sounds/bonus/superbonus_background");
        this.sndFon.loop(true);

        this.winTable = [];
        this.currentWinIndex = 0;
        this.queueFlow = []; // массив для порядка перетеканя выигрыша в конце бонуса
    }

    terminate() {
        this.superBonusBack = null;
        this.animPaintingsLight.gotoAndStop(0);
        this.animPaintingsLight = null;
        this.animMather.gotoAndStop(0);
        this.animMather = null;
        this.animFather.gotoAndStop(0);
        this.animFather = null;
        this.animIdle.gotoAndStop(0);
        this.animIdle = null;
        this.animLose.gotoAndStop(0);
        this.animLose = null;
        this.objectsButton = null;
        this.winAnimations = null;
        this.objectNumbers = null;
        this.totalBetLabel = null;
        this.plateForBet = null;
        this.winLabel = null;
        this.plateForWin = null;
        this.creditLabel = null;
        this.plateForCredits = null;
        this.plateCreditsLabel = null;
        this.addWinLabel = null;
        this.sndLose.stop();
        this.sndLose = null;
        this.sndWin = null;
        this.sndFon.stop();
        this.sndFon = null;
        this.winTable = null;
        this.currentWinIndex = null;

        this.removeChildren();
        this.destroy();
    }

    // resume = function (data) {
    //     console.log("RESUME SUPERBONUS WITH DATA" + JSON.stringify(data));
    //
    //     if (data.scenarioData === undefined) this.sndStart.play();
    //
    //     Scene.prototype.resume.call(this);
    //
    //     this.totalBetLabel.text = data.totalBet.toString();
    //     this.winLabel.text = data.currentWin.toString();
    //     this.creditLabel.text = data.credits.toString();
    //
    //     this.currentWinIndex = 0;
    //     this.winTable = [];
    //
    //     this.animMonkeyWait.gotoAndPlay(0);
    //     this.leftBox.enabled = !this.observerMode;
    //     this.rightBox.enabled = !this.observerMode;
    // };
    //
    // pause = function () {
    //     Scene.prototype.pause.call(this);
    //
    //     this.leftBox.enabled = false;
    //     this.rightBox.enabled = false;
    //
    //     this.animMonkeyWait.gotoAndStop(0);
    //     this.animMonkeyWait.visible = false;
    //
    //     this.animWin.visible = false;
    //     this.animWin.gotoAndStop(0);
    //
    //     this.animLose.visible = false;
    //     this.animLose.gotoAndStop(0);
    //
    //     this.animMonkeyLose.visible = false;
    //     this.animMonkeyLose.gotoAndStop(0);
    //
    //     this.animWin.stop();
    //     this.sndLose.stop();
    // };

    // Перетекания выигрыша за призы после окончания бонуса
    flowWins (done) {

        // отсортируем массив по возрастанию
        this.queueFlow.sort(function (a, b) {
            return a - b;
        });

        var self = this;

        // Массив твинов для перетекания каждого выигрыша отдельно
        const arrTweens = [];

        // Создаем твины
        for (let i = 0; i < this.queueFlow.length; i++) {

            if (this.winTable[this.queueFlow[i]] > 0) {

                const idx = this.queueFlow[i];
                // берем значение из лейбла
                const val = this.winTable[this.queueFlow[i]];//+this.addWinLabel[this.queueFlow[i]].text;
                const time = 100 * Math.log(val);

                const win = {
                    value: val,
                    index: idx,
                    from: val
                };

                const flowTween = new TWEEN.Tween(win)
                    .to({value: 0}, time)
                    // .onStart(() => {
                    //     if (!self.sndFlow.playing()) self.sndFlow.play();
                    // })
                    .onUpdate(function () {
                        const value = this.value | 0;
                        const delta = this.from - value;
                        this.from -= delta;

                        self.winLabel.text = parseInt(self.winLabel.text) + delta;
                        self.addWinLabel[this.index].text = value.toString();
                    })
                    .onComplete(function () {
                        self.addWinLabel[this.index].visible = false;
                        // if (self.sndFlow.playing()) self.sndFlow.stop();
                    });
                arrTweens.push(flowTween);
            }
        }

        // создаем цепочку из tween'ов, что бы они запускались друг за другом, слева направо как в оригинале
        for (let i = 1; i < arrTweens.length; i++) {
            arrTweens[i - 1].chain(arrTweens[i]);
        }

        //последний заканчивает перетекание
        arrTweens[arrTweens.length - 1].onComplete(function () {
            for (let i = 0; i < self.addWinLabel.length; ++i) {
                self.addWinLabel[i].visible = false;
            }
            // if (self.sndFlow.playing()) self.sndFlow.stop();
            // done();
            setTimeout(function () {
                self.sndFon.stop();
                done();
            }, 500);
        });

        arrTweens[0].delay(1000)
            .start();
    }

    // @overridden
    selectionHasMade(variant) {
        console.log("sb selectionHasMade");
        for (let i = 0; i < this.objectsButton.length; ++i) {
            this.objectsButton[i].interactive = false;
        }
    }

    // Разблокировать все активные кнопки
    enableButtonsExclusive (selectedItems) {
        console.log("sb enableButtonsExclusive");
        for (let i = 0; i < this.objectsButton.length; i++) {
            if (selectedItems.indexOf(i) == -1) {
                this.objectsButton[i].interactive = true;
                this.objectsButton[i].visible = true;
            }
            else {
                this.objectsButton[i].interactive = false;
                this.objectsButton[i].visible = false;
            }
        }
    }

    // @overridden
    showFinishTable(stageMath, bet, done) {
        console.log('### showFinishTable');
        for (let i = 0; i < this.objectsButton.length; ++i) {
            this.objectsButton[i].visible = true;
            this.objectsButton[i].gotoAndStop(0);
            this.winAnimations[i].gotoAndStop(0);
            this.winAnimations[i].visible = false;
            this.addWinLabel[i].visible = false;
            this.addWinLabel[i].text = "";
        }
        this.animLose.gotoAndStop(0);
        this.animLose.visible = false;
        this.animFather.gotoAndStop(0);
        this.animFather.visible = false;
        this.animMather.gotoAndStop(0);
        this.animMather.visible = false;
        this.animPaintingsLight.gotoAndStop(0);
        this.animPaintingsLight.visible = false;
        this.sndFon.stop();
        done();
    }

    // @overridden
    showResult(data, done) {
        console.log("SHOW SUPERBONUS RESULT WITH DATA: ", data);

        const bet = data.server.price();

        //обнулим перед каждым бонусом
        this.queueFlow.length = 0;

        this.totalBetLabel.text = bet;
        this.creditLabel.text = data.server.credits;

        let currentWin = data.server.totalWinInCoins;

        this.currentWinIndex = 0;
        this.winTable = [0, 0, 0, 0, 0];

        var self = this;

        for (let i = 0; i < this.objectsButton.length; ++i) {
            this.objectsButton[i].gotoAndPlay(0);
            this.objectsButton[i].visible = true;
            this.objectsButton[i].interactive = true;
            this.objectNumbers[i].visible = true;
            this.objectNumbers[i].visible = true;
            this.winAnimations[i].onComplete = null;
        }

        const scenarioData = data.server.scenarioData || [];

        this.animIdle.visible = true;
        this.animIdle.gotoAndPlay(0);

        this.animFather.visible = true;
        this.animMather.visible = true;

        // все предыдущие элементы отрисованы должны быть заранее
        if (data.state.stage.math.bonus2Wins) {
            for (let i = 0; i < scenarioData.length - 1; i++) {
                if (data.state.stage.math.bonus2Wins[i] > 0) {
                    currentWin -= data.state.stage.math.bonus2Wins[i] * data.server.betValue.multiplier;
                }

                const owen = scenarioData[i];
                const win = data.state.stage.math.bonus2Wins[i] * data.server.betValue.multiplier;

                // this.winAnimations[owen].visible = true;
                // this.winAnimations[owen].gotoAndStop(this.winFramesCount[owen]);
                this.objectsButton[owen].visible = false;
                this.objectsButton[owen].interactive = false;

                this.objectNumbers[owen].visible = false;

                this.winAnimations[owen].gotoAndStop(this.winFramesCount[owen] - 1);
                this.winAnimations[owen].visible = true;

                this.addWinLabel[owen].text = win;
                this.addWinLabel[owen].visible = true;
                this.addWinLabel[owen].position.set(this.coordWinLabel.x[owen], this.coordWinLabel.y[owen]);
                this.winTable[owen] = win;
            }
            currentWin -= data.state.stage.math.bonus2Wins[data.state.stage.math.bonus2Wins.length-1] * data.server.betValue.multiplier;
            this.currentWinIndex = scenarioData.length - 1;
        }

        this.winLabel.text = currentWin;

        if (scenarioData && scenarioData.length > 0) {
            this.selectionHasMade(scenarioData[scenarioData.length - 1]);

            var winInBet = data.state.stage.math.bonus2Wins[data.state.stage.math.bonus2Wins.length - 1];
            let previousWin = data.server.totalWinInCoins;

            if (winInBet) {
                previousWin -= winInBet * bet;
            }

            const index = data.server.scenarioData[data.server.scenarioData.length - 1];
            this.objectNumbers[index].visible = false;

            // при удаче отображаем выигрыш и продолжаем бонус
            if (winInBet > 0) {
                this.winTable[index] = winInBet * data.server.betValue.multiplier;
                this.sndWin[index].play();
                this.winAnimations[index].visible = true;
                this.winAnimations[index].gotoAndPlay(0);
                this.objectsButton[index].visible = false;
                this.winAnimations[index].onComplete = () => {
                    // this.winAnimations[index].gotoAndStop(this.winFramesCount[index]);
                    this.addWinLabel[index].text = winInBet * data.server.betValue.multiplier;
                    this.addWinLabel[index].position.set(this.coordWinLabel.x[index], this.coordWinLabel.y[index]);
                    this.addWinLabel[index].visible = true;
                    this.enableButtonsExclusive(scenarioData);
                    done();
                };
            }
            // при неудаче завершаем бонус
            else {
                this.sndLose.play();
                this.animFather.visible = true;
                this.animFather.gotoAndPlay(0);
                this.animMather.visible = true;
                this.animMather.gotoAndPlay(0);
                this.animLose.visible = true;
                this.animIdle.visible = false;
                this.animLose.gotoAndPlay(0);
                this.animPaintingsLight.gotoAndPlay(0);
                this.animPaintingsLight.visible = true;
                this.animPaintingsLight.onComplete = () => {
                    this.animPaintingsLight.visible = false;
                    this.animPaintingsLight.gotoAndStop(0);
                };

                this.queueFlow = scenarioData.slice();
                // если были выигрыши
                if (this.currentWinIndex > 0) {
                    this.flowWins(() => {
                        setTimeout(done, 500);
                    });
                }
                else {
                    this.animMather.onComplete = () => {
                        setTimeout(done, 500);
                    }
                }
            }
        }
        else {
            //     this.animMonkeyLose.visible = false;
            //     this.monkeyWin.visible = false;
            //     this.animLose.visible = false;
            //     this.animWin.visible = false;
            //     this.monkeyWait.visible = true;
                this.winLabel.text = data.server.totalWinInCoins;
            //     this.leftBox.enabled = !this.observerMode;
            //     this.rightBox.enabled = !this.observerMode;
            //     this.leftBox.visible = true;
            //     this.rightBox.visible = true;
            if (!this.sndFon.playing()) this.sndFon.play();
        }
    }
}


// WEBPACK FOOTER //
// ./src/superbonusgame_scene.es6